module.exports = require('../dist/utils/date');
